const config = {
    apiBaseURL: process.env.NODE_ENV === 'production' 
        ? 'https://api.eduframework.ca'  // Production URL
        : 'http://localhost:4000',        // Development URL
    clientBasedURL:process.env.NODE_ENV === 'production'? 
        'https://eduframework.ca' 
        : 'http://localhost:3000'
    };

export default config;